import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fieldMetaPropTypes } from 'redux-form';

const LocationService = ({ meta: { error } }) => {
  const companyPhone = useSelector(
    ({ companyDetails }) => companyDetails.phoneNumbers,
  );
  if (!error) return null;
  return (
    <div className="alert alert-danger">
      {error}
      {companyPhone && (
        <span className="ml-1">
          Please give us a call at
          <a className="ml-1 mr-1" href={`tel:${companyPhone}`}>{companyPhone}</a>
          to discuss options.
        </span>
      )}
    </div>
  );
};

LocationService.propTypes = {
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
};
LocationService.defaultProps = {};

export default LocationService;
